import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import {
  isContactSubmission,
  isTestDriveSubmission,
  decodeContactTopic,
} from "../../../utils/testDriveSubmissions";

/**
 * @param {{ variant?: "testdrive" | "contact" }} props
 */
const UserSubmissionsTable = ({ variant = "testdrive" }) => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");

  const [submissions, setSubmissions] = useState([]);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await axios.get(`${API_BASE}/api/TestDrive/requests`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setSubmissions(res.data);
      } catch (err) {
        console.error("Failed loading submissions:", err);
      }
    };

    load();
  }, [API_BASE]);

  const filtered = useMemo(() => {
    if (variant === "contact") {
      return submissions.filter(isContactSubmission);
    }
    return submissions.filter(isTestDriveSubmission);
  }, [submissions, variant]);

  const deleteSubmission = async (id) => {
    if (!window.confirm("Are you sure you want to delete this submission?")) return;

    try {
      await axios.delete(`${API_BASE}/api/TestDrive/requests/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      setSubmissions(submissions.filter((s) => s.id !== id));
    } catch (err) {
      console.error("Delete failed:", err);
      alert("Failed to delete.");
    }
  };

  const title =
    variant === "contact"
      ? "Contact form submissions"
      : "Test drive submissions";

  const rowDate = (s) => {
    const raw = s.createdAt ?? s.date;
    if (raw == null) return "—";
    return new Date(raw).toLocaleString();
  };

  const modelCell = (s) => {
    if (variant === "contact") return decodeContactTopic(s.model);
    return s.model;
  };

  return (
    <div className="mt-5">
      <h3 className="mb-3">{title}</h3>
      <p className="text-muted small mb-3">
        {variant === "contact"
          ? "Entries from the Contact us page (marked in the database via the model field)."
          : "Entries from Book a Test Drive. Contact form entries are listed under Contact submissions."}
      </p>

      <table className="table table-striped table-bordered">
        <thead className="table-dark">
          <tr>
            <th>#</th>
            <th>{variant === "contact" ? "Topic" : "Model"}</th>
            <th>Name</th>
            <th>City</th>
            <th>Email</th>
            <th>Telephone</th>
            <th>Message</th>
            <th>Date</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          {filtered.length === 0 ? (
            <tr>
              <td colSpan="9" className="text-center p-3">
                No submissions found.
              </td>
            </tr>
          ) : (
            filtered.map((s, index) => (
              <tr key={s.id}>
                <td>{index + 1}</td>
                <td>{modelCell(s)}</td>
                <td>
                  {s.firstName} {s.surname}
                </td>
                <td>{s.city}</td>
                <td>{s.email}</td>
                <td>{s.telephone}</td>
                <td style={{ maxWidth: "250px" }}>{s.message}</td>
                <td>{rowDate(s)}</td>
                <td>
                  <button
                    className="btn btn-sm btn-danger"
                    onClick={() => deleteSubmission(s.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default UserSubmissionsTable;
